import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";

const activityRecordState = (state: RootState) => state.component.activityRecord;

export const getActiveTab = createSelector(activityRecordState, ({ activeTab }) => activeTab);

export const getChildActivities = createSelector(
  activityRecordState,
  ({ recordData }) => recordData.childActivities
);

export const getChildActivitiesTotal = createSelector(
  activityRecordState,
  ({ recordData }) => recordData.childActivitiesTotal
);

export const getAssociations = createSelector(
  activityRecordState,
  ({ recordData }) => recordData.associations
);

export const isChildActivitiesLoading = createSelector(
  activityRecordState,
  ({ childActivitiesLoading }) => childActivitiesLoading
);

export const isAddCompanyLoading = createSelector(
  activityRecordState,
  ({ addCompanyLoading }) => addCompanyLoading
);

export const isAddDealLoading = createSelector(
  activityRecordState,
  ({ addDealLoading }) => addDealLoading
);

export const isSetPeopleLoading = createSelector(
  activityRecordState,
  ({ setPeopleLoading }) => setPeopleLoading
);

export const areFilesUploading = createSelector(
  activityRecordState,
  ({ filesUploading }) => filesUploading
);

export const getActivity = createSelector(
  activityRecordState,
  ({ recordData }) => recordData.activity
);

export const isActivityUpdateLoading = createSelector(
  activityRecordState,
  ({ activityUpdateLoading }) => activityUpdateLoading
);

export const isDeleting = createSelector(activityRecordState, ({ deleteLoading }) => deleteLoading);

export const isEntityRelating = createSelector(
  activityRecordState,
  ({ entityRelating }) => entityRelating
);

export const isEntityRelatingSuccessful = createSelector(
  activityRecordState,
  ({ entityRelatingSuccess }) => entityRelatingSuccess
);

export const getRecordData = createSelector(activityRecordState, ({ recordData }) => recordData);

export const isActivityRecordChanged = createSelector(
  activityRecordState,
  ({ hasChanges }) => hasChanges
);

export const isLoading = createSelector(activityRecordState, ({ loading }) => loading);

export const isPostponeLoading = createSelector(
  activityRecordState,
  ({ postponeLoading }) => postponeLoading
);

export const isToggleCompleteLoading = createSelector(
  activityRecordState,
  ({ toggleCompleteLoading }) => toggleCompleteLoading
);
